/**
 * Hero Section Component
 * "Study With Me" - Primary brand focus
 * Features main video with inspirational overlay and surrounding collage
 */

import React from 'react';
import MediaEmbed from './MediaEmbed';
import { useAutoplay } from '../context/AutoplayContext';

// Add your custom collage images here!
// Place images in the /public/hero-collage/ directory
const HERO_COLLAGE_IMAGES = [
  'IMG_4897.webp', 'IMG_4839.webp', 
  'IMG_4337.webp', 'Screenshot_.webp',
  'IMG_4570.webp', 'IMG_4526.webp', 
  'IMG_0615.webp', 'IMG_4398.webp', 
  'IMG_4879.webp', 'IMG_4063.webp', 
  'IMG_4075.webp', 'IMG_0464.webp', 
  'IMG_E3971.webp', 'IMG_4700.webp', 
  'IMG_4701.webp', 'IMG_4613.webp', 
  'IMG_0676.webp', 'IMG_4795.webp', 
  'IMG_6225.webp', 'IMG_4873.webp', 
  'IMG_4019.webp', 'IMG_4330.webp', 
  'IMG_5236.webp', 'IMG_0108.webp', 
  'IMG_0054.webp', 'IMG_4113.webp', 
  'IMG_4353.webp', 'Screenshot__.webp',
  'IMG_4559.webp', 'IMG_4871.webp', 
  'IMG_6270.webp', 'IMG_4164.webp', 
  'IMG_0009.webp', 'IMG_5154.webp', 
  'IMG_4196.webp', 'IMG_4712.webp', 
  'IMG_4972.webp', 'IMG_4026.webp', 
  'IMG_0383.webp'
];

const HeroSection = ({ heroContent }) => {
  const { shouldAutoplay } = useAutoplay();
  const isAutoplay = shouldAutoplay('study-anchor');

  return (
    <section
      id="study-anchor"
      className="min-h-screen relative flex items-center justify-center bg-gradient-to-br from-pink-50 via-purple-50 to-lavender-50 overflow-hidden"
    >
      {/* Background collage - desktop only */}
      {HERO_COLLAGE_IMAGES.length > 0 && (
        <div className="hidden md:grid absolute inset-0 grid-cols-6 grid-rows-4 gap-4 p-8 opacity-20">
          {HERO_COLLAGE_IMAGES.slice(0, 12).map((imageName, index) => (
            <div
              key={index}
              className={`rounded-lg overflow-hidden ${
                index % 3 === 0 ? 'col-span-2 row-span-2' : 'col-span-1 row-span-1'
              }`}
            >
              <img
                src={`/hero-collage/${imageName}`}
                alt={`Collage ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      )}

      {/* Main content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 py-12 md:py-20">
        <div className="flex flex-col items-center gap-8">
          {/* Hero video */}
          <div className="w-full max-w-6xl">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl video-glow">
              {heroContent ? (
                <MediaEmbed
                  item={heroContent}
                  aspectRatio="16/9"
                  className="w-full"
                  autoplay={isAutoplay}
                />
              ) : (
                <div className="w-full aspect-video bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center">
                  <div className="text-center text-white">
                    <h2 className="text-4xl font-bold mb-4">Study With Me</h2>
                    <p className="text-xl opacity-80">Gussying up...</p>
                  </div>
                </div>
              )}

            </div>
          </div>

          {/* CTA or description */}
          <div className="text-center max-w-2xl">
            <p className="text-gray-700 text-lg leading-relaxed">
            Take a peek at my journey through womanhood.
            </p>
          </div>

          {/* Scroll indicator */}
          <div className="mt-8 animate-bounce">
            <svg
              className="w-6 h-6 text-gray-400"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
